

import DeleteButton from './components/DeleteButton.vue'
import PublicShareButton from './components/PublicShareButton.vue'
import SimpleModal from './components/SimpleModal.vue'
import RecruiterMobileNav from './components/layout/RecruiterMobileNav.vue'
import AdminMobileNav from './components/layout/AdminMobileNav.vue'
import AdminStaticNav from './components/layout/AdminStaticNav.vue'
import AdminNavButton from './components/layout/AdminNavButton.vue'
import ProfileDropdown from './components/layout/ProfileDropdown.vue'
import ChangePortalSelect from './components/ChangePortalSelect.vue'
import HintedInput from './components/HintedInput.vue'
import FileUploadSingle from './components/FileUploadSingle.vue'
import FileUploadMultiple from './components/FileUploadMultiple.vue'
import MediaCardSimple from './components/MediaCardSimple.vue'
import CandidateAssigner from './components/CandidateAssigner.vue'
import CandidateCard from './components/CandidateCard.vue'
import ButtonPrimary from './components/ButtonPrimary.vue'
import ButtonSecondary from './components/ButtonSecondary.vue'
import LinkPrimary from './components/LinkPrimary.vue'
import LinkSecondary from './components/LinkSecondary.vue'
import FlashMessage from './components/FlashMessage.vue'
import SelectSingle from './components/SelectSingle.vue'
import SelectMultiple from './components/SelectMultiple.vue'
import ClientEndUserSelector from './components/ClientEndUserSelector.vue'
import {ArchiveBoxXMarkIcon, ShareIcon} from '@heroicons/vue/24/outline'
import VideoEditorInterface from './components/VideoEditorInterface.vue'
import CustomVideoList from './components/CustomVideoList.vue'
import RichTextEditor from './components/RichTextEditor.vue'
import {createApp} from 'vue'
import { createStore } from 'vuex'
import storeData from "./store/index"

import * as Sentry from "@sentry/vue";

if(import.meta.env.VITE_SENTRY_DSN_PUBLIC){
  Sentry.init({
    environment: import.meta.env.VITE_APP_ENV || 'local',
    dsn: import.meta.env.VITE_SENTRY_DSN_PUBLIC,
    integrations: [
      new Sentry.BrowserTracing({
        // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
        tracePropagationTargets: [/.*localhost/, /.*execpanels.com/,/.*stagingexecutivepanels.com/ ],
      }),
      new Sentry.Replay(),
    ],
    // Performance Monitoring
    tracesSampleRate: 1.0, // Capture 100% of the transactions
    // Session Replay
    replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
    replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
  });
}

import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

if(import.meta.env.VITE_PUSHER_APP_KEY){
  window.Pusher = Pusher;

  window.Echo = new Echo({
      broadcaster: 'pusher',
      key: import.meta.env.VITE_PUSHER_APP_KEY,
      cluster: import.meta.env.VITE_PUSHER_APP_CLUSTER,
      forceTLS: true,
  });
}

const store = createStore(storeData);

createApp({
  methods:{
    toggleNav(){
      this.$store.commit('toggleNav')
    },
    toggleProfile(){
      this.$store.commit('toggleProfile')
    },
  },
  components: {
    DeleteButton,
    PublicShareButton,
    SimpleModal,
    RecruiterMobileNav,
    AdminMobileNav,
    AdminStaticNav,
    AdminNavButton,
    ProfileDropdown,
    ChangePortalSelect,
    HintedInput,
    FileUploadSingle,
    FileUploadMultiple,
    MediaCardSimple,
    CandidateAssigner,
    CandidateCard,
    ButtonPrimary,
    ButtonSecondary,
    LinkPrimary,
    LinkSecondary,
    FlashMessage,
    SelectSingle,
    SelectMultiple,
    ClientEndUserSelector,
    VideoEditorInterface,
    CustomVideoList,
    ArchiveBoxXMarkIcon,
    ShareIcon,
    RichTextEditor,
  }
})
.use(store)
.mount('#app');
